<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-settings-brand"
      :title="$t(titleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      scrollable
      size="md"
      no-close-on-backdrop
    >
      <ValidationObserver ref="form-validation">
        <b-row>
          <!-- BRAND NAME -->
          <b-col cols="12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|max:100"
              name="name"
            >
              <b-form-group
                :label="$t('Brand name')"
                :state="errors[0] ? false : null"
              >
                <b-form-input
                  type="text"
                  v-model="form.name"
                  :class="{ 'border-danger': errors[0] }"
                ></b-form-input>
                <span v-if="errors[0]" class="text-danger">
                  {{ $t("Brand") }} {{ errors[0] }}
                </span>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <!-- Models -->

          <b-col cols="12" class="mt-1">
            <h3 class="p-0 m-0">{{ $t("Models") }}</h3>
            <hr class="p-0 m-0" />
            <div class="overflow-auto" style="height: 300px; margin-top=5px;">
              <div
                v-for="(mod, index) in form.models"
                :key="index"
                class="mt-1 d-flex align-items-center justify-content-between"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|max:100"
                  name="name"
                  class="w-100"
                >
                  <b-form-input
                    type="text"
                    v-model="mod.name"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                </ValidationProvider>
                <feather-icon
                  v-if="mod.id == null"
                  icon="DeleteIcon"
                  size="30"
                  class="text-danger cursor-pointer ml-1"
                  @click="deleteItem(index)"
                />
                <!-- <feather-icon
                  v-if="mod.id != null"
                  icon="DeleteIcon"
                  size="30"
                  class="text-danger cursor-pointer ml-1"
                  @click="deleteItem(index)"
                /> -->
              </div>
              <div class="mt-1">
                <b-button
                  :variant="isDarkSkin ? 'dark' : 'light'"
                  size="sm"
                  class="btn-icon"
                  @click="addItem"
                >
                  <tabler-icon icon="PlusIcon" />
                  {{ $t("Add model") }}
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </ValidationObserver>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                variant="outline-danger"
                @click="$emit('hideModal', false)"
                v-t="'CANCEL'"
              >
              </b-button>
              <b-button
                v-if="form.id == null"
                :disabled="form.models == 0 && form.id == null"
                variant="outline-primary"
                @click="save"
              >
                {{ $t(titleButton) }}
              </b-button>

              <b-button
              v-if="form.id != null"
                :disabled="form.models == 0 && form.id != null"
                variant="outline-warning"
                @click="edit"
              >
                {{ $t(titleButton) }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import VehicleService from "@/views/commons/vehicles/services/vehicle.service.js";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      form: {
        id: null,
        name: null,
        models: [],
      },
    };
  },
  props: {
    brandID: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.toggleModal("modal-settings-brand");
  },
  async created() {
    try {
      this.addPreloader();
      this.form.id = this.brandID;
      await Promise.all([this.getDataBrandById()]);
    } catch (error) {
      console.log(error);
      this.showToastError("Proceso fallido", "Error");
    } finally {
      this.removePreloader();
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    titleModal() {
      return this.brandID == null ? "NEW BRAND" : "EDIT BRAND";
    },
    titleButton() {
      return this.brandID == null ? "SAVE" : "UPDATE";
    },
  },
  methods: {
    async getDataBrandById() {
      if (this.brandID == null) return;
      try {
        const { data } = await VehicleService.getDataBrandById({
          brand_id: this.brandID,
        });
        this.form.name = data.name;
        this.form.models = data.models;
        console.log("form: ", this.form);
      } catch (error) {
        throw error;
      }
    },

    async save() {
      const validate = await this.$refs["form-validation"].validate();
      if (!validate) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      try {
        this.addPreloader();

        const params = {
          brand_id: this.brandID,
          name: this.form.name,
          models: this.form.models,
          user_id: this.currentUser.id,
        };

        const { data } = await VehicleService.saveVehicleBrand(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    async edit() {
      const validate = await this.$refs["form-validation"].validate();
      if (!validate) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      try {
        this.addPreloader();

        const params = {
          brand_id: this.brandID,
          name: this.form.name,
          models: this.form.models,
          user_id: this.currentUser.id,
        };

        const { data } = await VehicleService.editVehicleBrand(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },


    addItem() {
      const model = {
        id: null,
        name: null,
        vehicle_brand_id: null,
      };
      this.form.models.push(model);
    },

    deleteItem(indexx) {
      const models = this.form.models.filter((mod, index) => index != indexx);
      this.form.models = models;
    },
  },
};
</script>

<style lang="scss">
</style>